module.exports = __webpack_public_path__ + "img/header-weddingRingsStarrySky.c713395.webp";